<template>
  <div v-if="!showResponse" class="container">
    <h2>Actualizar contraseña</h2>
    <p>
      Introduzca su nueva contraseña. La misma debe incluir letras, números y simbolos para brindar un mejor nivel de
      seguridad.
    </p>
    <form @submit.prevent="actualizarPassword">
      <InputText
        id="password"
        label="Nueva Contraseña"
        placeholder="Ingresar contraseña nueva.."
        v-model="pass"
        v-on:keyup="cleanErrorMessage"
      />
      <InputText
        id="password-confirm"
        label="Repetir nueva contraseña"
        placeholder="Repetir contraseña nueva.."
        v-model="passConfirm"
      />
      <p v-show="errorMessage" class="error-label">{{ errorMessage }}</p>
      <Button class="mt-35" type="submit" text="Enviar" classtype="primary" :disabled="!token" />
      <Button class="mt-35" type="button" text="Volver" classtype="back" @click="goToLogin" />
    </form>
  </div>
  <Response
    v-else
    :success="responseSuccess"
    :title="responseTitle"
    :message="responseMessage"
    buttonText="Iniciar Sesión"
    :goToPage="LOGIN"
    showButton="yes"
  />
</template>
<script setup>
import { ref, computed } from "vue"
import { goToLogin, OK, LOGIN, getRouterToken } from "@/helpers"
import Button from "@/components/Button"
import { useAuthStore } from "@/store"
import InputText from "../components/InputText.vue"
import Response from "../components/Response.vue"

const pass = ref("")
const passConfirm = ref("")
const authStore = useAuthStore()

const token = computed(() => {
  return getRouterToken()
})

const showResponse = ref(false)
const responseSuccess = ref(false)
const responseTitle = ref("")
const responseMessage = ref("")
const errorMessage = ref("")

const cleanErrorMessage = () => {
  console.log("ejecuto clean") // TODO: test it on mobile
  errorMessage.value = ""
}

const actualizarPassword = () => {
  authStore.resetPassword(pass.value, passConfirm.value, token.value).then((response) => {
    console.log("resp", response)
    if (response.result == OK) {
      responseTitle.value = "¡Contraseña actualizada!"
      responseMessage.value = "Su contraseña en H2O fue actualizada correctamente."
      responseSuccess.value = true
      showResponse.value = true
    } else {
      responseTitle.value = "¡Error!"
      responseMessage.value = response.message
      errorMessage.value = response.message
      responseSuccess.value = false
    }
  })
}
</script>
